import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { useEffect } from 'react'
import { validateMinMaxValue } from '../../../utils/validateMinMaxValue'
import AddressSelectSearch from '../../../components/SelectSearch/AddressSelectSearch'

const menuItemsFlashTypeSender = [
  { label: 'ธรรมดา (Standard delivery)', value: 1 },
  { label: 'บริการ Speed (On-Time Delivery)', value: 2 },
  { label: 'ราคาพิเศษสำหรับพัสดุขนาดใหญ่ (Bulky delivery)', value: 4 },
  { label: 'ลูกค้าไม่รับ ตีกลับพัสดุฟรี (Happy Return)', value: 6 },
  {
    label:
      'ลูกค้าไม่รับ ตีกลับพัสดุฟรี สำหรับพัสดุขนาดใหญ่ (Happy Return Bulky)',
    value: 7,
  },
  { label: 'จัดส่งผลไม้ (Fruit delivery)', value: 5 },
]

const menuItemsFlashTypeProduct = [
  { label: 'เอกสาร', value: 0 },
  { label: 'อาหารแห้ง', value: 1 },
  { label: 'ของใช้', value: 2 },
  { label: 'อุปกรณ์ไอที', value: 3 },
  { label: 'เสื้อผ้า', value: 4 },
  { label: 'สื่อบันเทิง', value: 5 },
  { label: 'อะไหล่รถยนต์', value: 6 },
  { label: 'รองเท้า/กระเป๋า', value: 7 },
  { label: 'อุปกรณ์กีฬา', value: 8 },
  { label: 'เครื่องสำอางค์', value: 9 },
  { label: 'เฟอร์นิเจอร์', value: 10 },
  { label: 'ผลไม้', value: 11 },
  { label: 'อื่นๆ', value: 99 },
]

interface Props {
  setOptions: any
  options: any
}

export const OptionsFlashExpress = (props: Props) => {
  const { setOptions, options } = props

  useEffect(() => {
    setOptions({
      ...options,
      typeSender: 1,
      typeProduct: 4,
      isGuarantee: false,
    })
  }, [])

  return (
    <>
      <Grid item xs={12} lg={6}>
        <AddressSelectSearch
          label="เลือกที่อยู่ในการตีกลับ (หากไม่เลือกจะใช้ที่อยู่ในการจัดส่ง)"
          onSelect={(e) => {
            const address = e?.value
            setOptions({
              ...options,
              returnAddress: address
                ? {
                    name: address.name,
                    phone: address.phoneNumber,
                    address: address.address,
                    subDistrict: address.subDistrict,
                    district: address.district,
                    province: address.province,
                    postcode: address.postcode,
                  }
                : null,
            })
          }}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="typeSender-label">ประเภทการส่ง</InputLabel>
          <Select
            id="typeSender"
            name="typeSender"
            labelId="typeSender-label"
            value={options?.typeSender ?? 1}
            onChange={(e) =>
              setOptions({
                ...options,
                typeSender: Number(e.target.value) as number,
              })
            }
            fullWidth
          >
            <MenuItem disabled value="" selected>
              <em>เลือกประเภทการส่ง</em>
            </MenuItem>
            {menuItemsFlashTypeSender.map((item, index: number) => (
              <MenuItem value={item.value} key={index}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={6}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="typeProduct-label">ประเภทสินค้า</InputLabel>
          <Select
            id="typeProduct"
            name="typeProduct"
            labelId="typeProduct-label"
            value={options?.typeProduct ?? 0}
            onChange={(e) =>
              setOptions({
                ...options,
                typeProduct: Number(e.target.value) as number,
              })
            }
            fullWidth
          >
            <MenuItem disabled value="" selected>
              <em>เลือกประเภทสินค้า</em>
            </MenuItem>
            {menuItemsFlashTypeProduct.map((item, index: number) => (
              <MenuItem value={item.value} key={index}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={6}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="isGuarantee-label">ซื้อประกัน</InputLabel>
          <Select
            id="isGuarantee"
            name="isGuarantee"
            labelId="isGuarantee-label"
            value={Number(options?.isGuarantee ? 1 : 0)}
            onChange={(e) =>
              setOptions({
                ...options,
                isGuarantee: Boolean(e.target.value) as boolean,
              })
            }
            fullWidth
          >
            <MenuItem disabled value="" selected>
              <em>เลือกซื้อประกัน</em>
            </MenuItem>
            <MenuItem value={0}>ไม่ซื้อประกัน</MenuItem>
            <MenuItem value={1}>ซื้อประกัน</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {options?.isGuarantee && (
        <Grid item xs={12} lg={6}>
          <TextField
            id="priceGuarantee"
            fullWidth
            label="มูลค่าความคุ้มครอง (สตางค์) 1 บาท"
            name="priceGuarantee"
            type={'number'}
            onKeyPress={(e) => {
              if (['+', '-', 'e', '*'].includes(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={(e) =>
              setOptions({
                ...options,
                priceGuarantee: validateMinMaxValue(
                  e.target.value,
                  1,
                  9999999,
                ) as number,
              })
            }
            value={options?.priceGuarantee}
          />
        </Grid>
      )}
    </>
  )
}
